import PropTypes from "prop-types";
import React, { Fragment } from "react";
import { Autocomplete, Textfield } from "cxa-components";
import FormField from "./FormField";
import { decodeHtmlContent } from "../../../utils";

const formatAutocomplete = (value, { items, labelKey, valueKey }) => {
  if (value) {
    value = decodeHtmlContent(value);
  }
  const lookup =
    value && items.find(item => item[valueKey].trim().toLowerCase() === value.trim().toLowerCase());
  return lookup ? lookup[labelKey] : value;
};

const normalizeAutocomplete = (value, { items, labelKey, valueKey }) => {
  const lookup =
    value && items.find(item => item[labelKey].trim().toLowerCase() === value.trim().toLowerCase());
  return lookup ? lookup[valueKey] : value;
};

const renderReadOnlyField = ({ value, disabled, ...props }) => (
  <Textfield value={value} disabled={disabled} />
);

renderReadOnlyField.propTypes = {
  value: PropTypes.string,
  disabled: PropTypes.bool,
};
const renderAutocompleteField = props => (
  <Fragment>
    <Autocomplete {...props} />
    {props.helpText && props.helpText != "#void help text#" && (
      <div className="help-text">{props.helpText}</div>
    )}
  </Fragment>
);

const AutocompleteField = ({ valueKey = "value", labelKey = "label", readOnly, ...rest }) => {
  const props = { valueKey, labelKey, ...rest };

  if (readOnly) {
    return <FormField component={renderReadOnlyField} boxed {...props} />;
  }

  return (
    <FormField
      component={renderAutocompleteField}
      boxed
      format={value => formatAutocomplete(value, props)}
      normalize={value => normalizeAutocomplete(value, props)}
      {...props}
    />
  );
};

AutocompleteField.propTypes = {
  valueKey: PropTypes.string,
  labelKey: PropTypes.string,
  readOnly: PropTypes.bool,
};

export default AutocompleteField;



// WEBPACK FOOTER //
// ./components/common/form-field/AutocompleteField.js